import { ExclusivePlaylistCard } from "@iyk/vf-ui"
import { Analytics, useAnalytics } from "../../../packages/analytics/analytics.ts"
import { ActivityEvent } from "../../activity/activity.ts"
import { useActivity } from "../../activity/use-activity.tsx"
import { Profile } from "../profile.ts"
import { ExclusiveGalleryCard } from "./exclusive-gallery-card.tsx"
import { ExclusiveSweepstakeCard } from "./exclusive-sweepstake.tsx"
import { ExclusiveVideoCard } from "./exclusive-video-card.tsx"

const ExclusiveCard = (props: ExclusiveCard.Props) => {
  const analytics = useAnalytics()
  const activity = useActivity()

  return Profile.Exclusive.$match(props.exclusive, {
    Sweepstake: (props) => (
      <ExclusiveSweepstakeCard
        id={props.id}
        title={props.title}
        subtitle={props.subtitle}
        coverImage={props.coverImage}
        isWinner={props.isWinner}
        announcementDate={props.announcementDate}
        description={props.description}
      />
    ),
    Video: (props) => (
      <ExclusiveVideoCard
        id={props.id}
        title={props.title}
        subtitle={props.subtitle}
        coverImage={props.coverImage}
        videoSrc={props.videoSrc}
        autoPlay
        onPlay={() => {
          analytics.track(Analytics.Event.ExclusiveVideoPlayed({ exclusiveId: props.id }))
          activity.track(ActivityEvent.ExclusiveVideoPlayed({ exclusiveId: props.id }))
        }}
      />
    ),
    Gallery: (props) => (
      <ExclusiveGalleryCard
        id={props.id}
        title={props.title}
        coverImage={props.coverImage}
        media={props.media}
      />
    ),
    Playlist: (props) => (
      <ExclusivePlaylistCard
        playlist={{
          ...props.playlist,
          tracks: props.playlist.tracks.map((track) =>
            track._tag === "Released"
              ? {
                  ...track,
                  playbackLink: {
                    url: track.playbackUrl,
                    expiresAt: "", // TODO: fill with real value if available
                  },
                }
              : track,
          ),
        }}
        onOpenExclusive={() =>
          analytics.track(Analytics.Event.ExclusiveViewed({ exclusiveId: props.id }))
        }
      />
    ),
  })
}

namespace ExclusiveCard {
  export type Props = {
    exclusive: Profile.Exclusive
    owned: boolean
  }
}

export const ExclusiveCardList = ({ exclusives, owned }: ExclusiveCardList.Props) => {
  return exclusives.map((exclusive) => (
    <ExclusiveCard key={exclusive.id} exclusive={exclusive} owned={owned} />
  ))
}

namespace ExclusiveCardList {
  export type Props = {
    exclusives: Array<Profile.Exclusive>
    owned: boolean
  }
}
